import { Link } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
function PhoneNumberLink({ color }: { color?: string }) {
    const externalBookingSettings = useExternalBookingSettings().data;

    if (!externalBookingSettings?.phoneNumber) return null;

    const href = `tel:${externalBookingSettings.phoneNumber}`;
    return (
        <Link href={href} color={color}>
            {externalBookingSettings.phoneNumber}
        </Link>
    );
}

export { PhoneNumberLink };
